<template>
    <div class="codics-aonaer-info-sys-web-header" ref="sysWebHeader">
        <div class="codics-aonaer-info-sys-web-header-container">
            <el-image class="codics-aonaer-info-sys-web-header-container-logo"
                src="https://cdn.bosscaigou.com/huayuan/img/logo.svg" fit="fill"></el-image>
            <div v-show="userInfo != null" class="codics-aonaer-info-sys-web-header-container-user-box"
                style="margin-left: 15px;">
                <el-image class="codics-aonaer-info-sys-web-header-container-user-himg"
                    :src="userInfo?.user?.himg == null ? 'https://cdn.bosscaigou.com/huayuan/img/yasuo_60bc7e65a6d385d503656e12772d226.webp' : ('https://cdn.bosscaigou.com/' + userInfo?.user?.himg)"
                    fit="fill"></el-image>
                <div class="codics-aonaer-info-sys-web-header-container-user-nick"
                    style="padding-right: 0px !important;">{{ userInfo?.user?.nickname || '测试用户'
                    }}</div><span class="iconfont codics-aonaer-info-sys-web-header-container-user-nick"
                    style="padding-left: 0 !important;">&nbsp;&nbsp;&nbsp;&#xe83d;</span>
                <div class="codics-aonaer-info-sys-web-header-container-user-menu">
                    <div class="codics-aonaer-info-sys-web-header-container-user-menu-item"
                        v-for="(item, index) in menuList" :key="index" v-html="item" @click="menuClick(item)"></div>
                </div>
            </div>
            <div v-show="userInfo == null" class="codics-aonaer-info-sys-web-header-container-user-login-btn"
                @click="loginDialog = true;">登录/注册</div>
            <div class="codics-aonaer-info-sys-web-header-container-user-btn" v-for="(item, index) in topList"
                @click="topClick(item)" :key="index">
                <div class="codics-aonaer-info-sys-web-header-container-user-btn-tag"
                    :style="{ 'color': item.name === $route.name ? '#ea5b18' : '#FFF', 'background': item.name === $route.name ? '#FFF' : 'unset' }"
                    v-html="item.name"></div>
            </div>
        </div>
        <LoginDialog v-model="loginDialog" :lock="true"></LoginDialog>
    </div>
</template>

<script>
import LoginDialog from '@/components/LoginDialog';
import { mapState } from 'vuex';
import { jumpTo } from '@/utils/myutils';
export default {
    props: {
        tagindex: {
            type: Number,
            default: 6
        }
    },
    data() {
        return {
            loginDialog: false,
            menuList: ['个人主页', '退出登录'],
            topList: [
                {
                    id: 1,
                    name: '集团新闻',
                    path: ''
                },
                {
                    id: 2,
                    name: '耗邦邦',
                    path: 'https://www.www.haobangbang.cn/'
                },
                {
                    id: 3,
                    name: '飞斯智能',
                    path: ''
                },
                {
                    id: 4,
                    name: '万市德',
                    path: ''
                },
                {
                    id: 5,
                    name: '华誉机械',
                    path: 'https://huayuchina.com.cn/'
                },
                {
                    id: 6,
                    name: '奥纳尔制冷',
                    path: 'https://www.aonaer.cn/'
                },
                {
                    id: 7,
                    name: '系统首页',
                    path: ''
                }
            ]
        }
    },
    mounted() {
        console.log(this.$route.name)
        this.menuList = this.userInfo?.user?.member == 0 ? ['个人主页', '后台管理', '退出登录'] : ['个人主页', '退出登录'];
        if (this.userInfo == null) {
            this.loginDialog = true;
        }
    },
    methods: {
        topClick(item) {
            if (item.path == '') {
                jumpTo(this, item.name, {}, {});
                return;
            }
            window.open(item.path, '_blank');
            // window.location = item.path;
        },
        menuClick(idx) {
            switch (idx) {
                case '个人主页':
                    jumpTo(this, "个人中心", {}, {});
                    break;
                case '后台管理':
                    jumpTo(this, "后台管理", {}, {});
                    break;
                case '退出登录':
                    this.$store.dispatch('logout');
                    jumpTo(this, "首页", {}, {});
                    break;
            }
        }
    },
    components: {
        LoginDialog
    },
    computed: {
        ...mapState(['userInfo']),
        nowIndex() {

        }
    }
}
</script>

<style>
.codics-aonaer-info-sys-web-header {
    height: 100px;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 11;
    background: #ea5b18;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-web-header-container {
    height: 100%;
    width: 100%;
    max-width: 1360px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
    padding: 20px 0;
}

.codics-aonaer-info-sys-web-header-container-logo {
    height: 72.72px;
    width: 150px;
    position: relative;
    float: left;
    top: 50%;
    transform: translateY(-50%);
}

.codics-aonaer-info-sys-web-header-container-user-box {
    height: 36px;
    width: fit-content;
    position: relative;
    float: right;
    box-sizing: border-box;
    /* background: rgba(255, 255, 255, .6); */
    border-radius: 18px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
}

.codics-aonaer-info-sys-web-header-container-user-himg {
    height: 100%;
    width: 36px;
    box-sizing: border-box;
    position: relative;
    float: left;
    border: 2px solid #FFF;
    border-radius: 18px;
}

.codics-aonaer-info-sys-web-header-container-user-nick {
    height: 100%;
    width: fit-content;
    position: relative;
    float: left;
    padding: 0 10px 0 15px;
    line-height: 36px;
    text-align: center;
    font-size: 16px;
    color: #FFF;
    font-weight: bolder;
    max-width: 80px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.codics-aonaer-info-sys-web-header-container-user-menu {
    height: fit-content;
    width: 156px;
    position: absolute;
    margin: auto;
    right: 0;
    top: 68px;
    box-sizing: border-box;
    padding: 10px 0;
    background: #FFF;
    box-shadow: 0 0 15px rgba(0, 0, 0, .1);
    visibility: hidden;
    opacity: 0;
    transition: .3s;
}

.codics-aonaer-info-sys-web-header-container-user-menu-item {
    height: 37px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 37px;
    text-align: center;
    font-size: 15px;
    color: #333;
    user-select: none;
    -webkit-user-drag: none;
    cursor: pointer;
    transition: .3s;
}

.codics-aonaer-info-sys-web-header-container-user-menu-item:hover {
    background: #EEE;
}

.codics-aonaer-info-sys-web-header-container-user-box:hover .codics-aonaer-info-sys-web-header-container-user-menu {
    visibility: visible;
    opacity: 1;
}

.codics-aonaer-info-sys-web-header-container-user-btn {
    height: 100%;
    width: fit-content;
    position: relative;
    float: right;
    box-sizing: border-box;
    padding: 0 10px;
}

.codics-aonaer-info-sys-web-header-container-user-btn-tag {
    height: 36px;
    width: fit-content;
    position: relative;
    float: left;
    border-radius: 18px;
    line-height: 35px;
    text-align: center;
    font-size: 17px;
    color: #FFF;
    top: 50%;
    transform: translateY(-50%);
    padding: 0 18.5px;
    cursor: pointer;
    transition: .3s;
}

.codics-aonaer-info-sys-web-header-container-user-btn-tag:hover {
    background: #FFF !important;
    color: #ea5b18 !important;
}

.codics-aonaer-info-sys-web-header-container-user-login-btn {
    height: 40px;
    width: fit-content;
    position: relative;
    float: right;
    line-height: 40px;
    top: 50%;
    transform: translateY(-50%);
    background: #FFF;
    color: #ea5b18;
    font-size: 14px;
    padding: 0 20px;
    box-sizing: border-box;
    border-radius: 20px;
    cursor: pointer;
    margin-left: 10px;
}

@media (max-width:768px) {
    .codics-aonaer-info-sys-web-header {
        padding-left: 10px !important;
    }

    .codics-aonaer-info-sys-web-header-container-user-btn {
        display: none !important;
    }
}
</style>